import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Dialog} from "primereact/dialog";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import LinearProgress from "@material-ui/core/LinearProgress";
import HeaderScreenPresval from "../../components/headerScreenPresval";
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";

const EmailAdmin = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                        <HeaderScreenPresval headerTitle="Administración \ Correo Administrativo"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.searchEmail}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <SubtitleLabel header="Correo" isBold={true}/>
                                    <InputText type="email" id="emailSr"
                                               onChange={props.onChangeTextFilter}
                                               value={props.emailSearch}
                                               placeholder="Ej. usuario@dominio.com.mx"/>
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <br/>
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12}>
                        <Button label="Agregar"
                                style={{'float': 'right'}}
                                onClick={props.addNewEmail}
                                className="p-button-secondary"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            rows={10}
                            paginator={true}
                            responsive={true}
                            value={props.dataEmails}
                            selectionMode="single"
                            onSelectionChange={props.handleSelectEmail}
                            selection={props.emailDelete}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="emailStr" header="Correo" style={{textAlign: 'left'}} sortable={true}/>
                            <Column header="Acciones" body={props.emailActionTemplate}
                                    style={{textAlign: 'right', width: '8em'}}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                    onHide={props.onHideDialog} closable={false}>
                {
                    props.email &&

                    <div className="p-grid p-fluid">
                        <div className="p-col-12" style={{padding: '.75em'}}>
                            <SubtitleLabel header="Correo Electrónico" isBold={true}/>
                            <InputText type="email" id="emailStr"
                                       onChange={props.onChangeTextDialog}
                                       value={props.email.emailStr}
                                       placeholder="Ex. usuario@servidor.com"/>
                        </div>
                    </div>
                }
            </Dialog>
            {props.confirmationMessage}
        </React.Fragment>
    )
};

export default EmailAdmin;